<template>
  <div class="screenshots-gallery-links-uploader">
    <h4 class="screenshots-gallery-links-uploader__title">
      Upload screenshots via imgur.com links
    </h4>

    <div class="screenshots-gallery-links-uploader__body">
      <ui-textbox
        v-model="textboxValue"
        elastic
        class="screenshots-gallery-links-uploader__textarea"
        placeholder="Enter links separated by line breaks. Don't forget to save your offer after uploading.
Only images and albums links are supported. Only JPG, JPEG, PNG formats are supported." />

      <button
        class="button button-additional screenshots-gallery-links-uploader__button"
        :disabled="isLoading || !textboxValue"
        @click="uploadImagesFromLinks">
        <template v-if="!isLoading">
          Upload
        </template>

        <template v-else>
          Uploading...
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import UiTextbox from 'Components/ui/Textbox/UiTextbox.vue';
import AppModel from 'Models/AppModel';

export default {
  name: 'ScreenshotsGalleryLinksUploader',
  components: { UiTextbox },

  data() {
    return {
      textboxValue: '',
      isLoading: false,
    };
  },

  methods: {
    async uploadImagesFromLinks() {
      const links = this.textboxValue.trim();
      this.textboxValue = '';

      this.isLoading = true;

      this.$axios
        .post(`${AppModel.API_URI}/currency_marketplace/offers/upload_screenshots_from_links`, {
          links,
        })
        .then((response) => {
          const screenshots = response.data?.successfully_uploaded_screenshots
            .flat()
            .map((screenshot) => `/storage${screenshot.uri}`);

          this.$emit('screenshots-uploaded', screenshots);

          if (response.data?.failed_to_upload_screenshots?.length) {
            const message = `Failed to upload screenshots from the following links:
              \n${response.data.failed_to_upload_screenshots.join('\n')}`;
            window.alert(message);
          }
        }).catch((error) => {
          console.error(error);
        }).finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.screenshots-gallery-links-uploader {
  padding: 24px;
  border-radius: 16px;
  background: $color--basic-menu;
}

.screenshots-gallery-links-uploader__title {
  margin-bottom: 16px;
  font-size: 19px;
  font-weight: 500;
  line-height: 23px;
  color: $color--basic-white
}

.screenshots-gallery-links-uploader__body {
  display: flex;
  align-items: end;
  gap: 16px;
}

.screenshots-gallery-links-uploader__button {
  padding: 15px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
}

.screenshots-gallery-links-uploader__textarea {
  background: $color--basic-dark-gray;
  border-radius: 5px;
  padding: 15px;
}
</style>
